import Icon from 'veui/components/Icon'
import { IconUserSync } from 'dls-icons-vue'

Icon.register('user-sync', IconUserSync)
